<template>
    <div class="tip-summary-table">
        <table class="total">
            <tr>
                <td class="name">{{ translations.pay.consumption }}</td>
                <td class="currency">{{ translations.currency.chf }}</td>
                <td class="amount">{{ toMoney(totalConsumption, true) }}</td>
            </tr>
            <tr v-if="discountAmount !== 0" class="discount">
                <td class="name">{{ translations.pay.discount }}</td>
                <td class="currency discount">{{ translations.currency.chf }}</td>
                <td class="amount discount">{{ toMoney(discountAmount, true) }}</td>
            </tr>
            <tr v-if="showTip">
                <td class="name">{{ translations.pay.tip }}</td>
                <td class="currency">{{ translations.currency.chf }}</td>
                <td class="amount">{{ toMoney(tip ?? 0, true) }}</td>
            </tr>
        </table>
    </div>
</template>

<script setup lang="ts">
    import { translations } from "@/shared/localization/translations";
    import { toMoney } from "@/shared/utils/format";

    // define props
    defineProps<{
        totalConsumption: number;
        discountAmount: number;
        tip: number | null;
        showTip: boolean;
    }>();
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .tip-summary-table {
        font-size: 16px;
        font-weight: 300;

        padding: 0.75em 0.375em 1.125em;
        border-top: 1px solid colors.$light-gray-100;

        table.total {
            width: 100%;
            line-height: 1.5em;
            color: colors.$fontColor;

            td.name {
                width: 100%;
            }

            td.currency {
                padding: 0 1em;

                &.discount {
                    color: colors.$pink;
                }
            }

            td.amount {
                text-align: right;

                &.discount {
                    color: colors.$pink;
                }
            }
        }
    }
</style>
